import { render, staticRenderFns } from "./StokResimBilgileri.vue?vue&type=template&id=09c2debe&"
import script from "./StokResimBilgileri.vue?vue&type=script&lang=js&"
export * from "./StokResimBilgileri.vue?vue&type=script&lang=js&"
import style0 from "./StokResimBilgileri.vue?vue&type=style&index=0&id=09c2debe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports